import React from 'react';
import { Queue } from '../../../types/models/queue';
import { QueueItem } from './queue-item';

interface QueuesProps {
  queues: Array<Queue>;
}

export function Queues(props: QueuesProps) {
  return (
    <>
      {props.queues.map((q) => (
        <QueueItem key={q.id} queue={q} />
      ))}
    </>
  );
}
